<template>
  <div>
    <slot name="top" />
    <base-section :large="isSectionLarge()" :small="isSectionSmall()">
      <slot />
    </base-section>
    <slot name="bottom" />
  </div>
</template>

<script>
export default {
  name: 'BaseContent',

  props: {
    section: String
  },

  methods: {
    isSectionLarge () {
      return this.section === 'large'
    },

    isSectionSmall () {
      return this.section === 'small'
    }
  }
}
</script>
